// extracted by mini-css-extract-plugin
export default {"selectorsBlock":"styles_selectorsBlock__PzL6e"};